import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import { useMultipleRefs } from '@hh.ru/magritte-common-use-multiple-refs';
import { useBreakpoint } from '@hh.ru/magritte-ui-breakpoint';

var styles = {"calling-code-input":"magritte-calling-code-input___Hb20f_3-0-18","callingCodeInput":"magritte-calling-code-input___Hb20f_3-0-18","calling-code-input-container":"magritte-calling-code-input-container___UXmHV_3-0-18","callingCodeInputContainer":"magritte-calling-code-input-container___UXmHV_3-0-18","disabled":"magritte-disabled___fvEeH_3-0-18","focused":"magritte-focused___Ok8x4_3-0-18","invalid":"magritte-invalid___kptbH_3-0-18","ghost-data":"magritte-ghost-data___zShvn_3-0-18","ghostData":"magritte-ghost-data___zShvn_3-0-18","focus-visible":"magritte-focus-visible___kbwmg_3-0-18","focusVisible":"magritte-focus-visible___kbwmg_3-0-18","flag-container":"magritte-flag-container___wsoAd_3-0-18","flagContainer":"magritte-flag-container___wsoAd_3-0-18","input-container":"magritte-input-container___WSSZi_3-0-18","inputContainer":"magritte-input-container___WSSZi_3-0-18","phone-input-container":"magritte-phone-input-container___D587K_3-0-18","phoneInputContainer":"magritte-phone-input-container___D587K_3-0-18","flag-emoji":"magritte-flag-emoji___pyJS7_3-0-18","flagEmoji":"magritte-flag-emoji___pyJS7_3-0-18","no-flag-emoji":"magritte-no-flag-emoji___yiuyr_3-0-18","noFlagEmoji":"magritte-no-flag-emoji___yiuyr_3-0-18"};

const CallingCodeInput = forwardRef(({ onFocus, onBlur, value, onChange, flag, onKeyDown, invalid, disabled, className, inputElementRef }, ref) => {
    const inputRef = useRef(null);
    const inputRefMultiplexer = useMultipleRefs(inputRef, inputElementRef);
    const [isFocused, setIsFocused] = useState(false);
    const [isFocusVisible, setIsFocusVisible] = useState(false);
    const { isMobile } = useBreakpoint();
    useEffect(() => {
        if (inputRef.current) {
            setIsFocusVisible(isFocused && inputRef.current.classList.contains('focus-visible'));
        }
    }, [isFocused]);
    return (jsxs("div", { className: classNames(styles.callingCodeInputContainer, className, {
            [styles.focusVisible]: isFocusVisible && !disabled,
            [styles.focused]: isFocused && !disabled,
            [styles.invalid]: invalid && !disabled,
            [styles.disabled]: disabled,
        }), tabIndex: disabled ? -1 : 0, onFocus: () => {
            if (disabled) {
                return;
            }
            if (!isMobile) {
                inputRef.current?.focus();
                return;
            }
            setIsFocused(true);
            onFocus();
        }, onBlur: () => {
            if (!isMobile) {
                return;
            }
            setIsFocused(false);
            onBlur();
        }, ref: ref, "data-qa": "magritte-phone-input-calling-code", children: [jsx("div", { className: styles.flagContainer, children: flag }), jsxs("div", { className: styles.inputContainer, children: [jsx("input", { ref: inputRefMultiplexer, onFocus: () => {
                            setIsFocused(true);
                            onFocus();
                        }, onBlur: () => {
                            setIsFocused(false);
                            onBlur();
                        }, onKeyDown: onKeyDown, className: styles.callingCodeInput, value: value, onChange: (event) => onChange(event.target.value), disabled: disabled, "data-qa": "magritte-phone-input-calling-code-input" }), jsx("div", { className: styles.ghostData, "data-qa": "magritte-phone-input-calling-code-value", children: value })] })] }));
});
CallingCodeInput.displayName = 'CallingCodeInput';

export { CallingCodeInput as C, styles as s };
//# sourceMappingURL=CallingCodeInput-gIrbwv6b.js.map
